import { makeModuleApiInfoSelector } from "@client/content/selectors";
import { apiAction } from "@client/lib/actions";
import { type BaseAppState, type EntityRef, Status } from "@client/types";
import { type Dispatch } from "redux";
import api from "./api";
import { localStateSelector, makeAggregateRequestSelector } from "./selectors";
import { type Kpi } from "./types";

export enum Actions {
  GetAggregateBegin = "NETWORK_SETTINGS_GET_AGGREGATE_BEGIN",
  GetAggregateFailure = "NETWORK_SETTINGS_GET_AGGREGATE_FAILURE",
  GetAggregateSuccess = "NETWORK_SETTINGS_GET_AGGREGATE_SUCCESS"
}

export type GetAggregateBeginActionData = EntityRef & Kpi.Api.GetAggregateRequest;
export type GetAggregateSuccessActionData = Kpi.Api.AggregateValue;
export const _getAggregate = apiAction<
  BaseAppState,
  GetAggregateBeginActionData,
  Kpi.Api.GetAggregateResponse,
  GetAggregateSuccessActionData
>({
  types: {
    begin: Actions.GetAggregateBegin,
    failure: Actions.GetAggregateFailure,
    success: Actions.GetAggregateSuccess
  },
  action: (state: BaseAppState, dispatch: any, args: GetAggregateBeginActionData) => {
    const apiInfo = makeModuleApiInfoSelector()(state, args);
    return api.getAggregate(apiInfo, args);
  }
});

export const getAggregate = (args: EntityRef) => async (dispatch: Dispatch<any>, getState: () => BaseAppState) => {
  const state = getState();
  const localState = localStateSelector(state, args);

  if (localState.status !== Status.None) {
    const request = makeAggregateRequestSelector()(state, args);

    if (request) {
      dispatch(
        _getAggregate({
          ...args,
          ...request
        })
      );
    }
  }
};
